



























































import { defineComponent, PropType, toRefs } from '@nuxtjs/composition-api';
import { SfProductCard } from '@storefront-ui/vue';
import type { Product } from '~/modules/catalog/product/types';
import {
  getName,
  getProductThumbnailImage,
  getPrice,
  getAverageRating,
  getTotalReviews,
  getShortDescription,
  getProductSku,
  getCoverImage,
} from "~/modules/catalog/product/getters/productGetters";
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';
import { useProductsWithCommonProductCardProps } from './useProductsWithCommonCardProps';
import CategoryProductPrice from '~/modules/catalog/category/components/views/CategoryProductPrice.vue';
import { useImage, useProduct, useUser } from "~/composables";
import { useAddToCart } from "~/helpers/cart/addToCart";
import useWishlist from "~/modules/wishlist/composables/useWishlist";
import commonHelper from "~/helpers/commonHelper";
export default defineComponent({
  components: {
    CategoryProductPrice,
    SfProductCard,
    SkeletonLoader,
    ProductContainer: () => import('~/components/Custom/Organisms/ProductContainer.vue'),
    ProductCard: () => import(/* webpackPrefetch: true */ "~/components/ProductCard.vue"),
  },
  props: {
    products: {
      type: Array as PropType<Product[]>,
      required: true,
    },
    pricesLoaded: Boolean,
    loading: Boolean,
  },
  emits: ['click:wishlist', 'click:add-to-cart'],
  setup(props) {
    const { imageSizes: { productCard: imageSize } } = useImage();
    const { products } = toRefs(props);
    const { productsWithCommonProductCardProps } = useProductsWithCommonProductCardProps(products);
    const { isAuthenticated } = useUser();
    const { stripTags } = commonHelper();
    const { addItemToCart, isInCart } = useAddToCart();
    const { getProductPath } = useProduct();
    const { isInWishlist, addOrRemoveItem } = useWishlist();
    const { getMagentoImage, imageSizes } = useImage();
    const addItemToWishlist = async (product) => {
      await addOrRemoveItem({ product });
    };
    return {
      imageSize,
      productsWithCommonProductCardProps,
      addItemToCart,
      addItemToWishlist,
      isAuthenticated,
      isInCart,
      stripTags,
      imageSizes,
      isInWishlist,
      getMagentoImage,
      getProductPath,
      getName,
      getProductThumbnailImage,
      getPrice,
      getAverageRating,
      getTotalReviews,
      getShortDescription,
      getProductSku,
      getCoverImage,
    };
  },
});
